import React, { useState } from 'react';
import '../../../scss/app.scss';
import "react-toggle/style.css"
import { BillingAccountsVService } from '../../../services/V2/gozer';
import { Button, Card, CardContent, CircularProgress, Dialog, DialogContent, DialogTitle } from '@mui/material';
import EnergySavingsLeafIcon from '@mui/icons-material/EnergySavingsLeaf';
import LoopIcon from '@mui/icons-material/Loop';
import { useHistory } from 'react-router-dom';
import { ConfirmModal } from '../../Shared/ConfirmModal';
import DOMPurify from 'dompurify';

export function EnrollmentSettings({ account, recurring, enrollment, setEnrollment, success }) {
    const history = useHistory();
    const [updatingEnrollment, setUpdatingEnrollment] = useState<boolean>(false);
    const [paperlessInfo, setPaperlessInfo] = useState<boolean>(false);
    const [showConfirm, setShowConfirm] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);

    const updatePaperless = async () => {
        setLoading(true)
        setUpdatingEnrollment(true)
        setShowConfirm(false)
        let enroll = await BillingAccountsVService.billingAccountsVUpdateEnrollment(account.id, {
                ...enrollment,
                paperBill: !enrollment.paperBill
            })
        success("Enrollments Updated")
        setPaperlessInfo(false)
        setEnrollment(enroll)
        setUpdatingEnrollment(false)
        setLoading(false)
    }

    const sanitizedTerms = () => ({
        __html: DOMPurify.sanitize(account.termsAndConditions?.paperlessTermsAndConditions),
    });

    return (
        <>
            <Card className='enrollment-card'>
                <Dialog
                    fullWidth
                    onClose={() => { }}
                    open={paperlessInfo}>
                        <DialogTitle>Terms and Conditions</DialogTitle>
                    <DialogContent>
                        {account.termsAndConditions &&
                            <div dangerouslySetInnerHTML={sanitizedTerms()} style={{ fontSize: "16px" }} />
                        }
                        <div className='enrollment-buttons-group'>
                            <Button variant="outlined" onClick={() => setPaperlessInfo(false)} color="primary" style={{marginRight:"10px"}}>Cancel</Button>
                            <Button variant="contained" onClick={updatePaperless} color="primary">Ok</Button>
                        </div>
                    </DialogContent>
                </Dialog>
                <ConfirmModal
                    cancelCallback={() =>setShowConfirm(false)}
                    show={showConfirm}
                    confirmCallback={updatePaperless}
                    title="Confirm"
                    description="Are you sure you want to remove paperless?"
                    fullWidth={false} />
                <CardContent style={{padding:"15px 0px 0px 15px"}}>
                    <div>
                        <div><strong>Enrollments</strong></div>
                        <div style={{ display: "flex", flexWrap: "wrap", justifyContent: "center" }}>
                            {account.allowPaperless &&
                                <button
                                    onClick={() => {
                                        if(enrollment?.paperBill)
                                            setPaperlessInfo(true)
                                        else{
                                            setShowConfirm(true)
                                        }}}
                                    style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center",
                                        width: "140px",
                                        margin: "10px 10px",
                                        fontSize: ".85rem",
                                        border: "none",
                                        background: "none",
                                        cursor: "pointer",
                                        padding: "0"
                                    }}
                                    className="enrollment-button"
                                    aria-label={updatingEnrollment ? "Updating Paperless" : enrollment ? (enrollment.paperBill ? "Enroll Paperless, currently receiving paper bills" : "Unenroll Paperless, currently enrolled in paperless billing") : "Update Paperless"}>
                                    <EnergySavingsLeafIcon style={{
                                        fontSize: "3.5em",
                                        display: 'flex',
                                        alignItems: 'center',
                                        width: "100%",
                                        color: enrollment && !enrollment.paperBill ? "#2d4a29" : "#757575"
                                    }} />
                                    <div style={{
                                        color: enrollment && !enrollment.paperBill ? "#2d4a29" : "#555555"
                                    }}>
                                        <b>{updatingEnrollment ? "Updating" : enrollment ? (!enrollment.paperBill ? "Unenroll" : "Enroll") : "Update"} Paperless</b>
                                    </div>
                                </button>
                            }
                            {(account.paymentInfo?.cc?.allowRecurringPayment || account.paymentInfo?.ach?.allowRecurringPayment) &&
                                <button
                                    onClick={() => history.push('/wallet')}
                                    style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center",
                                        width: "140px",
                                        margin: "10px 10px",
                                        fontSize: ".85rem",
                                        border: "none",
                                        background: "none",
                                        cursor: "pointer",
                                        padding: "0"
                                    }}
                                    className="enrollment-button"
                                    aria-label={`Manage Autopay, currently ${recurring ? 'enabled' : 'disabled'}`}>
                                    <LoopIcon style={{
                                        fontSize: "3.5em",
                                        width:"100%",
                                        display: 'flex',
                                        alignItems: 'center',
                                        color: recurring ? "#2d4a29" : "#757575"
                                    }} />
                                    <div style={{
                                        color: recurring ? "#2d4a29" : "#555555"
                                    }}>
                                        <b>Manage Autopay</b>
                                    </div>
                                </button>
                            }
                        </div>
                    </div>
                </CardContent>
            </Card>
            {loading && <div className='loading-container'><CircularProgress className='center-spinner' color="primary" aria-label="Loading" /></div>}
        </>
        )

}
